import { render } from "./EmployeePayments.vue?vue&type=template&id=47364c60"
import script from "./EmployeePayments.vue?vue&type=script&lang=js"
export * from "./EmployeePayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__